const units = ['B', 'kB', 'MB', 'GB', 'TB'];

/**
 * 아래와 같은 규칙
 * * 0 -> 0B
 * * 1024 -> 1kB
 * * 100 * 1024 * 1024 -> 100MB
 * * 999 * 1024 * 1024 -> 999MB
 * * 1000 * 1024 * 1024 -> 0.98GB
 * * 4.7 * 1000 * 1024 * 1024 -> 4.59GB
 * * 1024 * 1024 * 1024 -> 1GB
 * * 1.5 * 1024 * 1024 * 1024 -> 1.5GB
 * @param bytes bytes
 */
export const byteToString = (bytes: number) => {
  let index = 0;
  while (bytes >= 1000) {
    bytes /= 1024;
    index += 1;
  }
  const fixedBytes = bytes.toFixed(2);
  return `${parseFloat(fixedBytes) === bytes ? bytes : fixedBytes}${
    units[index]
  }`;
};
